import React, { useEffect, useState } from "react";
import axios from "axios";
import { Puff } from "react-loader-spinner";
import { Link } from "react-router-dom";
import "../assets/css/privacy-policy.css";

const PrivacyPolicy = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [title, setTitle] = useState("Privacy Policy");
  const [content, setContent] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const loadPrivacyPolicy = async () => {
      setIsLoading(true);
      setError("");
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/auth/listActive/PrivacyPolicy`
        );
        if (res.data?.isOk && res.data?.data) {
          setTitle(res.data.data.title || "Privacy Policy");
          setContent(res.data.data.content || "");
        } else {
          setContent("");
          setError("Privacy Policy content is not available yet.");
        }
      } catch (err) {
        console.error(err);
        setError("Unable to load Privacy Policy. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    loadPrivacyPolicy();
  }, []);

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="loader-container">
          <Puff color="#a01e20" height={50} width={50} timeout={0} />
        </div>
      ) : (
        <div>
          <nav className="breadcrumb-nav">
            <div className="container">
              <ul className="breadcrumb">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>Privacy Policy</li>
              </ul>
            </div>
          </nav>
          <div
            className="page-content mb-8 mt-8"
            style={{ textAlign: "start" }}
          >
            <div className="container">
              <div className="row">
                <div className="post-single-content">
                  <h4 className="title title-md font-weight-bold">
                    {title}
                  </h4>
                  {error ? (
                    <p className="mb-2">{error}</p>
                  ) : (
                    <div
                      className="privacy-policy-content"
                      dangerouslySetInnerHTML={{ __html: content }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default PrivacyPolicy;
